import { render, staticRenderFns } from "./RadioBase.vue?vue&type=template&id=4948286f&scoped=true&lang=pug&"
import script from "./RadioBase.vue?vue&type=script&lang=ts&"
export * from "./RadioBase.vue?vue&type=script&lang=ts&"
import style0 from "./RadioBase.vue?vue&type=style&index=0&id=4948286f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4948286f",
  null
  
)

export default component.exports